import { IError, IProfile, IQueryHookOptions } from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { removeSocialStatus } from 'services';

type RemoveSocialStatusFunction = UseMutateAsyncFunction<
  IProfile,
  IError,
  void
>;

type UseRemoveSocialStatus = [RemoveSocialStatusFunction, IQueryHookOptions];

export const useRemoveSocialStatus = (
  profileId = '',
): UseRemoveSocialStatus => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IProfile,
    IError,
    void
  >(() => removeSocialStatus(profileId), {
    onSuccess: (data) => {
      queryClient.setQueryData(['profiles', profileId], data);
    },
  });

  return [mutateAsync, { error, isError, isLoading }];
};
